import { useState, useEffect, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import logger from "@/lib/logger";

export function useCommandBarData(timer, boxColors) {
  const [liveStats, setLiveStats] = useState({ tasksToday: 0, completionPct: 0, totalTasks: 0, completedTasks: 0 });
  const [gameLevel, setGameLevel] = useState(1);
  const [streak, setStreak] = useState(0);

  const fetchLiveStats = useCallback(async () => {
    try {
      const boxes = await api.getBoxes();
      const allTasks = boxes.flatMap((b) => b.tasks || []);
      const total = allTasks.length;
      const completed = allTasks.filter((x) => x.completed).length;
      const today = new Date().toISOString().split("T")[0];
      const tasksToday = allTasks.filter((x) => x.completed && x.completed_at?.startsWith(today)).length;
      setLiveStats({ tasksToday, completionPct: total ? Math.round((completed / total) * 100) : 0, totalTasks: total, completedTasks: completed });
    } catch (e) { logger.error("fetchLiveStats:", e); }
  }, []);

  useEffect(() => { fetchLiveStats(); }, [fetchLiveStats]);
  useEffect(() => { const id = setInterval(fetchLiveStats, 15000); return () => clearInterval(id); }, [fetchLiveStats]);

  useEffect(() => {
    const fetchLevel = async () => {
      try { const prog = await api.getGameProgress(); setGameLevel(prog.global_level || 1); }
      catch (e) { logger.error("fetchLevel:", e); }
    };
    const fetchStreak = async () => {
      try { const st = await api.getDashboardStats(); setStreak(st.streak ?? 0); }
      catch (e) { logger.error("fetchStreak:", e); }
    };
    fetchLevel(); fetchStreak();
    const id = setInterval(() => { fetchLevel(); fetchStreak(); }, 30000);
    return () => clearInterval(id);
  }, []);

  const todayFocus = timer.focusStats?.daily_focus?.length > 0
    ? timer.focusStats.daily_focus[timer.focusStats.daily_focus.length - 1]?.minutes ?? 0 : 0;

  const byBox = useMemo(() => {
    return timer.boxes.map((b) => {
      const ts = b.tasks || [];
      const done = ts.filter((x) => x.completed).length;
      return { id: b.id, title: b.title, color: b.color, total: ts.length, done, pct: ts.length ? Math.round((done / ts.length) * 100) : 0 };
    }).filter((b) => b.total > 0);
  }, [timer.boxes]);

  return { liveStats, gameLevel, streak, todayFocus, byBox };
}
